import script from "./ActivationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationForm.vue?vue&type=script&setup=true&lang=js"

import "./ActivationForm.vue?vue&type=style&index=0&id=17ad1ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ad1ebc"]])

export default __exports__